import { get, set, del, createStore } from 'idb-keyval'

// Create a custom store so we don't mix heavy images with light JSON reports
const imagesStore = createStore('claim-ready-images-db', 'images')

export const saveImage = async (blob: Blob): Promise<string> => {
    const id = globalThis.crypto.randomUUID()
    const key = `local:${id}`
    await set(key, blob, imagesStore)
    return key
}

export const getImage = async (key: string): Promise<Blob | undefined> => {
    return await get<Blob>(key, imagesStore)
}

export const deleteImage = async (key: string): Promise<void> => {
    await del(key, imagesStore)
}
